/**
 * Clerk 認証ブリッジ
 *
 * `VITE_CLERK_PUBLISHABLE_KEY` が設定されている場合のみ Clerk を有効化する。
 * 未設定時は stub 開発モード（X-User-Id ヘッダー）にフォールバックする
 * （multi-tenant-enablement.md §5 / cloudflare.md「認証（Clerk）」参照）。
 *
 * API クライアント（api.ts / api/workItemsApi.ts）は ClerkProvider の外側にあるため、
 * React コンテキストを経由せずトークンを取得できるよう、モジュールレベルの
 * ゲッター登録機構を用意する。ClerkTokenBridge（App.tsx）が `useAuth().getToken` を
 * ここに登録する。
 */

export const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

export const isClerkEnabled = !!CLERK_PUBLISHABLE_KEY;

let tokenGetter: (() => Promise<string | null>) | null = null;

/** ClerkTokenBridge から呼ばれる。SignedIn 時のみマウントされるため、サインアウト時は自動的に未登録に戻す */
export function setAuthTokenGetter(getter: (() => Promise<string | null>) | null): void {
  tokenGetter = getter;
}

/** Clerk 無効時・未サインイン時は null を返す（stub モードの X-User-Id にフォールバック） */
export async function getAuthToken(): Promise<string | null> {
  if (!tokenGetter) return null;
  try {
    return await tokenGetter();
  } catch {
    return null;
  }
}
